module.exports = __webpack_public_path__ + "static/media/sunway.59b2fff6.png";